<template>
    <div class="dropdown">
        <button class="btn dropdown-toggle" type="button" :id="id" data-bs-toggle="dropdown" aria-expanded="false">
            <span v-html="defaultText ?? display"></span>
        </button>
        <ul class="dropdown-menu" :aria-labelledby="id">
            <li v-for="item in list" :key="item[trackBy]">
                <a :class="{'dropdown-item': 1, active: isCurrent(item)}"
                   :aria-current="isCurrent(item)"
                   @click.prevent="update($event, item)"
                   href="#">
                    <span v-html="item[label]"></span>
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
    import Prefs from '../../common/preferences';

    let ddCount = 1;

    export default {
        props: {
            modelValue: {
                default: () => null
            },
            defaultText: {
                type: String,
                default: () => null
            },
            label: {
                type: String,
                default: 'name'
            },
            list: Array,
            trackBy: {
                type: String,
                default: 'id'
            },
        },
        emits: ['update:model-value'],
        data: function () {
            return {
                display: '',
                id: '',
                value: null,
            }
        },
        /*computed: {
            buttonClass() {
                const c = Prefs.theme.value ? 'btn-light' : 'btn-outline-dark';
                return `btn ${c} dropdown-toggle`;
            }
        },*/
        watch: {
            //The order of watchers matters here
            value(value) {
                this.$emit('update:model-value', value);
                const trackBy = this.trackBy;
                const e = this.list?.find(i => i[trackBy] == value);
                this.display = e ? e[this.label] : '(None)';
            },
            modelValue: {
                handler(value) {
                    this.value = value;
                },
                immediate: true,
            },
        },
        methods: {
            isCurrent(item) {
                return this.value && this.value == item[this.trackBy];
            },
            update(event, item) {
                this.value = item[this.trackBy];
            },
        },
        created() {
            this.id = 'dropdown' + (ddCount++);
        },
    }
</script>